// extracted by mini-css-extract-plugin
export default {"button":"primaryButton_button__-m3Bm"};